import { configService } from './config.service';
import { RestClient } from '../utils/rest-client';
const restClient = RestClient(configService.restConfig);
async function getKreedaDetails(code) {
    const apiResponse = await restClient.get({
        openapiPath: '/kreedas/{Code}',
        pathParams: {
            Code: code,
        },
    });
    if (!apiResponse.body?.Data?.Kreeda) {
        throw new Error('Kreeda not found. Please check the code and try again.');
    }
    return apiResponse.body.Data.Kreeda;
}
const kreedaService = { getKreedaDetails };
export { kreedaService };
